import { arrayOf, func, shape, string } from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';

import { withDocumentTitle } from '../generic/DocumentTitle';
import Titled from '../layout/Titled';
import { merchantShape, opportunityShape } from '../prop-types';
import api from '../REST/api';
import DeleteButton from '../REST/DeleteButton';
import update from '../REST/update';
import { COLORS } from '../utils/constants';
import { tapFlashSuccess, tapFlashWarningMessages } from '../utils/flash';
import { salesChannelsEnum } from './constants';
import OpportunityForm from './OpportunityForm';
import {
  getTransformedOpportunity,
  transformForPatch,
  transformForRendering,
} from './transform-opportunity-helpers';

function getIdFromRoute(match) {
  return Number.parseInt(match.params.id, 10);
}

function UpdateOpportunity({ match, onSubmit, model, ...rest }) {
  const id = getIdFromRoute(match);
  const { salesChannel, salesforceId } = model;
  const isSalesforceOpp = !!salesforceId;

  const isSelfService = salesChannel === salesChannelsEnum.SELF_SERVICE;

  return (
    <Titled
      title="Edit Opportunity"
      actions={[
        !isSelfService && !isSalesforceOpp && (
          <DeleteButton
            onDelete={api.destroyOpportunity}
            id={id}
            name="Opportunity"
            redirectTo="/opportunities"
          />
        ),
        <Link to="show" className="btn btn-secondary ml-2">
          Cancel
        </Link>,
        <Button color={COLORS.PRIMARY} className="ml-2" onClick={onSubmit}>
          Save
        </Button>,
      ]}
      sticky
    >
      <OpportunityForm id={id} onSubmit={onSubmit} model={model} {...rest} />
    </Titled>
  );
}

UpdateOpportunity.propTypes = {
  model: opportunityShape.isRequired,
  match: shape({ params: shape({ id: string.isRequired }).isRequired })
    .isRequired,
  onSubmit: func.isRequired,
  merchants: arrayOf(merchantShape).isRequired,
};

export default update({
  query: getTransformedOpportunity,
  deriveQueryArgs: ({ match }) => ({
    id: getIdFromRoute(match),
  }),
  async update({ match, merchants }, changedModel, oldModel) {
    const id = getIdFromRoute(match);
    const warnings = {
      response: await api.getOpportunitiesValidCombinations({
        id,
        data: changedModel,
        skipError: true,
      }),
      id,
    };

    return api
      .patchOpportunity({
        id,
        data: await transformForPatch(changedModel, oldModel, merchants),
      })

      .then(transformForRendering)
      .then(tapFlashSuccess('Opportunity update successful'))
      .then(tapFlashWarningMessages({ ...warnings.response, id: warnings.id }));
  },
  form: withDocumentTitle(({ model }) => model.name)(UpdateOpportunity),
  redirectTo: '/opportunities/:id/show',
});
